import { render, staticRenderFns } from "./Wenfang.vue?vue&type=template&id=fa85cde0&scoped=true"
import script from "./Wenfang.vue?vue&type=script&lang=ts"
export * from "./Wenfang.vue?vue&type=script&lang=ts"
import style0 from "./Wenfang.vue?vue&type=style&index=0&id=fa85cde0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa85cde0",
  null
  
)

export default component.exports